import { cn } from '@/lib/utils';
import Dot from '@/components/ui/Dot.tsx';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/Tooltip.tsx';
import { BillRowVm } from '@/features/dashboard/bookingChanges/types/BillViewModel.ts';
import { cellClass, textCellClass } from './billRowStyles';

// Bez słowa „szkic”: `row.changed` bierze się z paczki otwartej, a ta bywa już
// wysłana do akceptacji.
const CHANGED_LABEL = 'Zmieniona w otwartej paczce';

/** Kolumna 1 — nazwa pozycji i kropka pozycji ruszonej w paczce. */
const LabelCell = ({ row }: { row: BillRowVm }) => (
  <div
    className={cn(
      cellClass,
      textCellClass,
      '@max-[640px]:col-start-1 @max-[640px]:row-start-1 @max-[640px]:pb-0 flex items-center gap-[7px]',
    )}
  >
    <span className="text-sm text-neutral-500">{row.label}</span>
    {row.changed && (
      <Tooltip>
        <TooltipTrigger asChild>
          <Dot size="sm" aria-label={CHANGED_LABEL} />
        </TooltipTrigger>
        <TooltipContent>{CHANGED_LABEL}</TooltipContent>
      </Tooltip>
    )}
  </div>
);

export default LabelCell;
